function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1046 1067",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M621.162,451.661l388.552,-451.661l-92.075,0l-337.38,392.17l-269.464,-392.17l-310.795,0l407.483,593.031l-407.483,473.636l92.08,-0l356.281,-414.146l284.575,414.146l310.795,-0l-422.592,-615.006l0.023,-0Zm-126.116,146.595l-41.287,-59.053l-328.502,-469.887l141.429,0l265.105,379.214l41.287,59.053l344.605,492.92l-141.429,-0l-281.208,-402.224l-0,-0.023Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "4.17px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.6782b288f30c1127601a2ba2d95e5b73.svg";
export { ForwardRef as ReactComponent };